"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerCard = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("office-ui-fabric-react/lib/Button");
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var components_1 = require("../../shared/components");
/**
 * LayerCard - Header row of a single strategy layer. Handles inline name
 * editing, expand / collapse, and delete confirmation. The nodes table is
 * rendered separately by the parent so each layer can manage its own
 * expansion state without remounting the editor.
 */
exports.LayerCard = function (_a) {
    var column = _a.column, isEditing = _a.isEditing, editingName = _a.editingName, isExpanded = _a.isExpanded, onStartEdit = _a.onStartEdit, onCancelEdit = _a.onCancelEdit, onConfirmEdit = _a.onConfirmEdit, onEditingNameChange = _a.onEditingNameChange, onToggleExpand = _a.onToggleExpand, onDelete = _a.onDelete;
    var _b = components_1.useConfirmDialog(), confirm = _b.confirm, confirmDialog = _b.dialog;
    var nodeCount = (column.nodes || []).length;
    var handleRowClick = function () {
        if (isEditing)
            return;
        onToggleExpand();
    };
    var handleRowKeyDown = function (e) {
        if (isEditing)
            return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggleExpand();
        }
    };
    var stopPropagation = function (e) { return e.stopPropagation(); };
    return (react_1.default.createElement("div", { className: "ws-column-item" + (isExpanded ? ' is-expanded' : ''), onClick: handleRowClick, role: isEditing ? undefined : 'button', tabIndex: isEditing ? undefined : 0, onKeyDown: handleRowKeyDown },
        !isEditing && (react_1.default.createElement(Button_1.IconButton, { iconProps: {
                iconName: isExpanded ? 'ChevronDown' : 'ChevronRight',
            }, title: isExpanded ? 'Collapse Elements' : 'Expand Elements', ariaLabel: isExpanded ? 'Collapse Elements' : 'Expand Elements', className: "ws-column-action-btn ws-admin-button-hover-accent ws-expand-btn", onClick: function (e) {
                e.stopPropagation();
                onToggleExpand();
            } })),
        react_1.default.createElement("div", { className: "ws-column-input" }, isEditing ? (react_1.default.createElement("div", { className: "ws-column-input-editing", onClick: stopPropagation },
            react_1.default.createElement(TextField_1.TextField, { placeholder: "Layer Name", value: editingName, onChange: function (_, newValue) { return onEditingNameChange(newValue || ''); }, autoFocus: true, onKeyPress: function (e) {
                    if (e.key === 'Enter')
                        onConfirmEdit();
                } }))) : (react_1.default.createElement("div", { className: "ws-column-name-container" },
            react_1.default.createElement("span", { className: "ws-column-readonly-name" }, column.name),
            react_1.default.createElement("sup", { className: "ws-node-count", title: nodeCount + " strategy element" + (nodeCount !== 1 ? 's' : '') },
                "(",
                nodeCount,
                " node",
                nodeCount !== 1 ? 's' : '',
                ")")))),
        react_1.default.createElement("div", { className: "ws-column-actions", onClick: stopPropagation }, isEditing ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: 'Accept' }, title: "Save Name", ariaLabel: "Save Name", className: "ws-column-action-btn ws-admin-button-hover-success", onClick: onConfirmEdit }),
            react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: 'Undo' }, title: "Discard Changes", ariaLabel: "Discard Changes", className: "ws-column-action-btn ws-admin-button-hover-accent", onClick: onCancelEdit }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: 'Edit' }, title: "Edit Layer Name", ariaLabel: "Edit Layer Name", className: "ws-column-action-btn ws-admin-button-hover-accent", onClick: onStartEdit }),
            react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: 'Delete' }, title: "Delete Layer", ariaLabel: "Delete Layer", className: "ws-column-action-btn ws-admin-button-hover-danger", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var ok;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, confirm({
                                    title: 'Delete layer',
                                    message: 'Are you sure you want to delete this layer?',
                                    variant: 'error',
                                    confirmText: 'Delete',
                                })];
                            case 1:
                                ok = _a.sent();
                                if (ok)
                                    onDelete();
                                return [2 /*return*/];
                        }
                    });
                }); } })))),
        confirmDialog));
};
